import ModalComponent from '@components/common/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoLogOutSharp } from 'react-icons/io5';
interface ILogout {
  visible: boolean;
  setVisible: (val: boolean) => any;
  callbackLogout: () => any;
}

export default function LogoutConfirm(props: ILogout) {
  const { t } = useTranslation();

  const handleCancel = () => {
    props.setVisible(false);
  };

  const handleOk = () => {
    props.callbackLogout();
  };

  return (
    <ModalComponent
      modalTitle={t('Logout.Title')}
      modalType="confirm"
      okText={t('Logout.Action')}
      visible={props.visible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div className="text-red-600 w-full flex flex-col items-center">
        <IoLogOutSharp size={50} />
        {t('Logout.Message')}
      </div>
    </ModalComponent>
  );
}
